"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mutateKeys(set, get) {
    return { set: set, get: get };
}
exports.mutateKeys = mutateKeys;
//# sourceMappingURL=mutateKeys.js.map